import React, { useEffect } from 'react'

import Header from '../../../components/Turkey/Header/Header'
import UnderHeader from '../../../components/UnderHeader/UnderHeader'
import PageTitle from '../../../components/Turkey/PageTitle/PageTitle'
import Footer from '../../../components/Turkey/Footer/Footer'
import LogoPartner from '../../../components/LogoPartner/LogoPartner'
import Subscribe from '../../../components/Turkey/Subscribe/Subscribe'
import CoperateContent from '../../../components/Turkey/CoperateContent/CoperateContent'

export default function Corperate() {
  useEffect(() => {
    window.scrollTo({ top:0 ,behavior: "smooth" })
  }, [])

  return (
    <div>
      <Header page={'corperate'} />
      <UnderHeader className={'corperate'} />
      <PageTitle mainTitle={'KURUMSAL'} page={'KURUMSAL'} />
      <CoperateContent />
      <Subscribe />
      <LogoPartner />
      <Footer />
    </div>
    
  )
}
